export const additionalRecordsCollectionName = "additionalRecords";
export const communityCollectionName = "community";
export const configCollectionName = "config";
export const driverCollectionName = "driver";
export const leaderboardCollectionName = "pickemLeaderboard";
export const matchCollectionName = "match";
export const orgCollectionName = "org";
export const pickemDetailsCollectionName = "pickemDetails";
export const teamCollectionName = "team";
export const tourCollectionName = "newTour";
export const tournamentCollectionName = "tournament";
export const tournamentAdminCollectionName = "tournamentAdmin";
export const tournamentDraftCollectionName = "tournamentDraft";
export const tournamentOrganizationCollectionName = "tournamentOrganization";
export const tourPointsCollectionName = "tourPoints";
export const trackCollectionName = "track";
export const userCollectionName = "user";
export const userPicksCollectionName = "newUserPicks";
export const usernameCollectionName = "username";
